module.exports = __webpack_public_path__ + "static/media/close-icon-ok.99a63f37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/RequestStatus/img/close-icon-ok.svg
// module id = 486
// module chunks = 0